import { useState } from 'react'

import Box from '@mui/material/Box'

import ShrimpSalesRecordBody from '../ShrimpSalesRecordBody'
import ShrimpSalesRecordDialog from '../ShrimpSalesRecordDialog'
import ShrimpSalesRecordCard from '../ShrimpSalesRecordCard'

const ShrimpSalesRecord = () => {
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  return (
    <Box>
      <ShrimpSalesRecordCard onClick={handleOpen}>
        <ShrimpSalesRecordBody />
      </ShrimpSalesRecordCard>
    </Box>
  )
}

export default ShrimpSalesRecord
